import React from 'react';
import { Link } from 'react-router-dom';
import { socialLinks } from '../data/socialLinks';

const footerLinks = [
  { path: '/credit', label: 'Portfolio' },
  { path: '/affiliates', label: 'Affiliates' },
  { path: '/games', label: 'Games' },
  { path: '/analytics', label: 'Analytics' },
  { path: '/history', label: 'History' },
  { path: '/about', label: 'About' },
];

function FooterSection() {
  return (
    <footer className="relative py-16 bg-dark-secondary border-t border-hash-gold/10">
      <div className="container-premium">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start">
            <Link to="/" className="flex flex-col md:flex-row items-center gap-3 mb-4">
              <img src="/images/logo.png" alt="HashMedora" className="h-10 w-auto object-contain" />
              <img src="/images/logo-text.png" alt="HashMedora" className="h-10 w-auto object-contain max-w-full" />
            </Link>
            <p className="text-gray-400 text-sm max-w-xs text-center md:text-left">
              Powered by Hash. Driven by Trust. The next generation of on-chain lottery gaming.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-start md:items-center">
            <h4 className="text-hash-gold font-semibold mb-4">Quick Links</h4>
            <nav className="flex flex-col gap-2 items-start md:items-center">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-gray-300 hover:text-hash-gold transition-colors text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Social Links */}
          <div className="flex flex-col items-start md:items-end">
            <h4 className="text-hash-gold font-semibold mb-4">Connect</h4>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full bg-dark-surface border border-hash-gold/20 flex items-center justify-center text-hash-gold hover:bg-hash-gold/10 hover:border-hash-gold/40 transition-all duration-300"
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-xs text-center md:text-left">
              &copy; {new Date().getFullYear()} HashMedora. All rights reserved.
            </p>
            <p className="text-gray-600 text-xs text-center">
              HashMedora is a decentralized lottery platform on BSC. Play responsibly.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterSection;
